import { api } from '@/redux/api';
import { RootState } from '@/redux/store';
import { OrganisationIdAndNameOnly } from '@/types/organisation';
import { findById } from '@/utils/find-by-id';

export const selectOrganisationById =
  (organisationId: number) =>
  (state: RootState): OrganisationIdAndNameOnly => {
    const { data: organisations } =
      api.endpoints.getOrganisations.select()(state);
    const organisation = findById(organisations ?? [], organisationId);
    return {
      id: organisationId,
      name: organisation?.name ?? '',
    };
  };
